import React, {useEffect, useRef, useState, Fragment, useCallback} from 'react';
import "./ProductRegalDesktopV3.scss";
import {useHistory} from "react-router-dom";
import {convertVariantTypeNameWithVal, getMallColor} from "../../Services";
import {getCats_api, getProductsCategory_api} from "../../Services/apis";
import {Swiper, SwiperSlide} from 'swiper/react';
import {Col, message, Row, Spin} from 'antd';
import SwiperId from "react-id-swiper";
import {PlusOutlined} from '@ant-design/icons';
import {useBasket, useDispatchBasket} from "../../hooks";
import {AddBasket, RemoveBasket} from "../OnlineAddress/OnlineAddressService";
import SwiperCore,{Autoplay, Pagination, Navigation } from "swiper";
import { RightOutlined,LeftOutlined } from '@ant-design/icons';

const imageParamss = {
    slidesPerView: 'auto',
    spaceBetween: 10,
    rtl:true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    },
    breakpoints: {
        1024: {
            slidesPerView: 5,
            spaceBetween: 20
        },
        768: {
            slidesPerView: 5,
            spaceBetween: 20
        },
        400: {
            slidesPerView: 'auto',
            spaceBetween: 8
        },
        320: {
            slidesPerView: 'auto',
            spaceBetween: 8
        }
    }

}


const catParams = {
    slidesPerView: 8,
    spaceBetween: 2,
    rtl:true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    }
}


function BasketAddRemoveSub({product,handleChangeProduct,changeOut}) {

    //hooks
    const setBasket = useDispatchBasket();
    const basket = useBasket();
    const history = useHistory();

    //states
    const [loading, set_loading] = useState(false)
    const [base, set_base] = useState(product)
    const [item, set_item] = useState(null)
    const [merchantId,set_merchantId] = useState(product.merchant.uid)



    useEffect(() => {
        if(product?.variants?.length > 0) {
            set_item(product.variants[0])
        }else{
            set_item(product)
        }
    }, [])

    const addToBasket = async (pId) => {
        const response = await AddBasket(merchantId, pId,item)
        console.log("Add : ", response)
    }

    const removeFromBasket = async (pId) => {
        const response = await RemoveBasket(merchantId, pId)
        console.log("Remove : ", response)
    }

    //functions
    const inc = async () => {
        console.log("ssssssssssssssssssss")
        if (loading) {
            return
        }


        let pickCount = basket.find(p=>p.product.uid===product.uid)

        if(pickCount && product.stock<pickCount.count+1){
            return message.error('درخواست شما بیشتر از سقف موجودی است');
        }

        if(pickCount && product.order_cap<pickCount.count+1){
            return message.error('درخواست شما بیشتر از سقف خرید است');
        }

        try {
            set_loading(true)
            //ADD API
            await addToBasket(item.uid);
            set_loading(false)
        } catch (e) {
            set_loading(false)
            return;
        }
        //--------------------------------- Context Change ----------------------------------------------
        //check exist in basket
        if (basket.find(product => product.product.uid === item.uid)) {
            //exist
            let filter = basket.map(pro => pro.product.uid === item.uid ? {...pro, count: pro.count + 1} : pro)
            //context change
            setBasket(filter);
            //storage change
            localStorage.setItem("basket", JSON.stringify(filter));
        } else {
            //not exist

            //context change
            setBasket(oldArray => [...oldArray, {product: item, count: 1}]);
            //storage change
            localStorage.setItem("basket", JSON.stringify([...basket, {product: item, count: 1}]));
        }


    }

    const dec = async () => {
        if (loading) {
            return
        }
        try {
            set_loading(true)
            //Remove API
            await removeFromBasket(item.uid)
            set_loading(false)
        } catch (e) {
            set_loading(false)
            return;
        }

        //--------------------------------- Context Change ----------------------------------------------
        //check exist in basket
        let find = basket.find(product => product.product.uid === item.uid);
        if (find) {
            //exist
            if (find.count > 0) {
                //exist
                let filter = basket.map(pro => pro.product.uid === item.uid ? {...pro, count: pro.count - 1} : pro)

                if (find.count === 1) {
                    //context change
                    setBasket(basket.filter(product => product.product.uid !== item.uid))
                    //storage change
                    localStorage.setItem("basket", JSON.stringify(basket.filter(product => product.product.uid !== item.uid)));
                } else {
                    //context change
                    setBasket(filter);
                    //storage change
                    localStorage.setItem("basket", JSON.stringify(filter));
                }
            } else {
                //context change
                setBasket(basket.filter(product => product.product.uid !== item.uid))
                //storage change
                localStorage.setItem("basket", JSON.stringify(basket.filter(product => product.product.uid !== item.uid)));
            }
        }


    }

    const remove = () => {
        //--------------------------------- Context Change ----------------------------------------------
        setBasket(basket.filter(product => product?.product?.uid !== item.uid))
        //--------------------------------- Local Storage Change ----------------------------------------------
        setTimeout(() => {
            localStorage.setItem("basket", JSON.stringify(basket));
        }, 500)
    }

    const checkCount = () => {
        if(!item)
            return 0

        let basket_count = basket.find(product => product?.product?.uid === item.uid);
        if (basket_count) {
            return basket_count.count;
        }
        return 0;
    }


    const handleVariantChange = (vId)=>{
        const  find = base.variants.find(v=>v.uid===vId)
        console.log("find : ",find)
        set_item(find)
        // handleChangeProduct(find)
    }

    useEffect(()=>{
        set_item(changeOut)
    },[changeOut])

    return (
        <div className="basket-actions">
            {/*{base?.variants?.length > 0 ?*/}
            {/*    <div className="var-section">*/}
            {/*        <select*/}
            {/*            onChange={e=>{*/}
            {/*                handleVariantChange(e.target.value)*/}
            {/*            }}*/}
            {/*            name="" id="">*/}
            {/*            {base.variants.map(v=>{*/}
            {/*                return(*/}
            {/*                    <option value={v.uid}>{convertVariantTypeNameWithVal(v.variant_type,v.variant_attr)}</option>*/}
            {/*                )*/}
            {/*            })}*/}
            {/*        </select>*/}
            {/*    </div>:*/}
            {/*    null*/}
            {/*}*/}

            {item && checkCount() > 0?<div className="dr-shop-add-remove-v2-change">
                {item && checkCount() > 0 ? <>
                    <i className="clickable fa fa-minus" onClick={dec}></i>
                    <span className="plusIcon product-count-number-v2">{!loading ? checkCount() : <i className="fa fa-spinner fa-spin"></i>}</span>
                </> : null}
                {item.stock>checkCount()?
                    <i className="clickable fa fa-plus" onClick={inc}></i>:
                    <span></span>
                }

            </div>:null}

            {item && checkCount() < 1?<div>
                {!loading?<i className="clickable plusIcon fa fa-plus" onClick={inc}></i>:
                    <i className="plusIcon fa fa-spinner fa-spin"></i>
                }


            </div>:null}


        </div>
    )
}



function numberWithCommas  (x) {
    if (x === 0) {
        return 0
    }
    if(x){
        x= Math.round(x)
        return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
    }

    return "-"

}

function limitText(txt,length) {
    if(txt.length>length){
        return txt.substr(0,length)+" ... "
    }else {
        return txt
    }
}


function ProductV2Card({product,item}){

    const history = useHistory()

    const [p,set_p] = useState(product)


    const goToProductDetail = ()=>{
        if(product.variants && product.variants.length > 0)
            history.push(`/dr-shop/detail/${product.merchant.uid}/${product.uid}`,{variant: p})
        else
            history.push(`/dr-shop/detail/${product.merchant.uid}/${product.uid}`)

    }

    useEffect(()=>{
        if(product.variants && product.variants.length>0){
            set_p({...product.variants[0],merchant:product.merchant})
        }else{
            set_p(product)
        }
    },[])

    const handleChangeProduct = (pr)=>{
        // console.log("product : ",pr)
        set_p({...pr,merchant:product.merchant})
    }
    const handleChangeVar = (vId)=>{
        let find = product.variants.find(v=>v.uid===vId)
        set_p({...find,merchant:product.merchant})
    }


    return(
                <div className="p-regal-desktop-v2-products-card">
                    <Fragment>
                        <div className="add-section">
                            <BasketAddRemoveSub product={p} handleChangeProduct={handleChangeProduct} changeOut={p}/>
                        </div>
                        <div className="p-regal-desktop-v2-products-card-wrapper" >
                            <div className="p-regal-desktop-v2-products-card-img pointer" onClick={e=>{
                                goToProductDetail()
                            }}>
                                <img
                                    src={p.image}
                                    alt=""/>
                            </div>
                            <div className="p-regal-desktop-v2-products-card-divider">
                                {/*<PlusOutlined />*/}
                            </div>
                            <div className="p-regal-desktop-v2-products-card-info" >
                                <span className="p-regal-desktop-v2-products-card-info-name">{limitText(p.name,50)}</span>
                                <span className="p-regal-desktop-v2-products-card-info-brand">{p?.brand?.name}</span>
                                {product.variants.length>1?
                                    <select
                                        className="var-select"
                                        onChange={e=>{
                                            handleChangeVar(e.target.value)
                                        }}
                                        name="" id="">
                                        {product.variants.map(v=>{
                                            if(v.is_active){
                                                return(
                                                    <option value={v.uid}>{convertVariantTypeNameWithVal(v.variant_type,v.variant_attr)}</option>
                                                )
                                            }
                                        })}
                                    </select>:null
                                }
                            </div>

                            <div className="p-regal-desktop-v2-products-card-footer" onClick={e=>{
                                goToProductDetail()
                            }}>


                                <div className="p-regal-desktop-v2-products-card-footer-badge">
                                    {p && p.discount_percentage && p.discount_percentage>0?<div className="p-regal-desktop-v2-products-card-footer-badge-off">
                                        <span>%{p.discount_percentage}</span>
                                    </div>:null}
                                </div>

                                <div className="p-regal-desktop-v2-products-card-footer-price">
                                    {p.price_original-p.price>0?
                                        <span className="p-regal-desktop-v2-products-card-footer-price-off">{numberWithCommas(p.price_original/10)}</span>:
                                        <span></span>}
                                    <span className="p-regal-desktop-v2-products-card-footer-price-price">{numberWithCommas(p.price/10)} تومان</span>
                                </div>

                            </div>
                        </div>

                    </Fragment>
                </div>

    )
}

function ProductRegalDesktopV3({item,sort=false}) {
    SwiperCore.use([Autoplay])
    const history = useHistory();

    const sliderRef = useRef(null);


    const handlePrev = useCallback(() => {
        if (!sliderRef.current) return;
        sliderRef.current.swiper.slidePrev();
    }, []);

    const handleNext = useCallback(() => {
        if (!sliderRef.current) return;
        sliderRef.current.swiper.slideNext();
    }, []);

    const [cats,set_cats] = useState([]);
    const [selectedCat,set_selectedCat] = useState(null);
    const [products,set_products] = useState([]);
    const [cat_banner,set_cat_banner] = useState("")
    const [cat_name,set_cat_name] = useState("")
    const [spin,set_spin] = useState(false)

    useEffect(()=>{
       set_cats(item.items.reverse())
        if(item.items.length>0)
            initCats(item.items[item.items.length-1])
    },[])

    const initCats = (cat)=>{
        set_selectedCat(cat)
        getCat(cat)
    }

    const handleSelectCat = (c)=>{
        console.log(c)
        set_selectedCat(c)
        getCat(c)
    }

    const getCat = async (cat)=>{
        set_spin(true)
        let merchantId = cat.text
        let catId = cat.link_to_uid
        try{
            const res = await getProductsCategory_api(merchantId, catId)
            set_cat_banner(res.category_image)
            set_cat_name(res.category_name)
            set_products([])
            set_products(res.results)
            set_spin(false)
        }catch (e) {
            set_spin(false)
            console.log(e)
        }
    }

    const seeMoreProduct = ()=>{
        let merchantId = selectedCat.text
        let catId = selectedCat.link_to_uid
        history.push(`/dr-shop/search/${merchantId}/${catId}`)
    }

    const [sw,set_sw] = useState(null)
    return(
        <div className="p-regal-desktop-v2-container">
            <div className="nav-regal">
                <LeftOutlined className="custom-button-prev clickable" onClick={handlePrev}  />
                <RightOutlined className="custom-button-next clickable" onClick={handleNext} />
            </div>
            <Row className="v2-wrapper" style={{backgroundColor:selectedCat?.subtitle}}>
                <Col className="left-slider v2-card-color"  span={20}>
                    <div  className="p-regal-desktop-v2-cats">
                                {cats && cats.length>0 && cats.map(d=>{
                                    return(
                                        <div className={selectedCat?.uid===d.uid?"p-regal-desktop-v2-cats-item active-item":"p-regal-desktop-v2-cats-item"}  onClick={e=>{
                                            handleSelectCat(d)
                                        }}>
                                            <span>{d.title}</span>
                                        </div>
                                    )
                                })}
                    </div>
                    <Spin spinning={spin}>
                        <Row>
                         <div className="p-regal-container">
                             <Swiper
                                 ref={sliderRef}
                                 autoplay={{
                                     delay: 3000,
                                     pauseOnMouseEnter: true,
                                     disableOnInteraction: false
                                 }}
                                 loop={false}
                                 dir={"rtl"}
                                 spaceBetween={10}
                                 slidesPerView={5}
                                 onSlideChange={() => console.log('slide change')}
                             >
                                 {products.map(i=>{
                                     return(
                                         <SwiperSlide>
                                             <ProductV2Card item={item} product={i}/>
                                         </SwiperSlide>
                                     )
                                 })}
                             </Swiper>

                         </div>

                        </Row>
                    </Spin>


                </Col>

                <Col className="right-slider" span={4}>
                    <div className="p-regal-desktop-v3-banner-sec">
                        <img src={selectedCat?.image} alt=""/>
                        <h6>{selectedCat?.title}</h6>
                        <span className="clickable" onClick={seeMoreProduct}>مشاهده همه</span>
                    </div>
                </Col>

            </Row>




        </div>
    )
}

export default ProductRegalDesktopV3;

